// 导入自己需要的组件
import { Popconfirm } from 'element-ui'
const element = {
    install: function (Vue) {
         Vue.use(Popconfirm)
    }
}
export default element
